const $ = require('jquery/dist/jquery');
global.$ = global.jQuery = $;
window.$ = window.jQuery = $;
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
window.bootstrap = bootstrap;
// require('@popperjs/core/lib/popper.js');
import Lightbox from 'bs5-lightbox'
import { lazyLoad } from 'unlazy'

$(document).ready(function(){
    lazyLoad();

    for (const el of document.querySelectorAll('.lightbox-toggle')) {
        el.addEventListener('click', Lightbox.initialize)
    }
    // To Scroll Top
    $("#backToTop").hide();
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                $('#backToTop').fadeIn();
            } else {
                $('#backToTop').fadeOut();
            }
        });
        // scroll body to 0px on click
        $('#backToTop').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 100);
            return false;
        });
    });
});


